import { MessageCircle, Clock3 } from "lucide-react";
import { waLink } from "../../lib/api";
import { Reveal } from "../../lib/motion";

const VARIANTS = [
  "lg:col-span-7 bg-ink text-paper",
  "lg:col-span-5 bg-crimson text-paper",
  "lg:col-span-12 bg-paper-2 text-ink border border-line",
];

export default function Offers({ offers }) {
  if (!offers || offers.length === 0) return null;

  return (
    <section id="ofertas" data-testid="offers-section" className="relative bg-paper ledger-bg-paper py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-crimson font-semibold flex items-center gap-3">
            <span className="w-8 h-px bg-crimson" /> Ofertas em destaque
          </p>
          <h2 className="mt-5 font-display font-extrabold tracking-tightest text-4xl md:text-6xl leading-[0.98] text-ink max-w-3xl">
            Condições especiais para as{" "}
            <span className="text-crimson">20 primeiras empresas.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-4">
          {offers.map((offer, idx) => {
            const variant = VARIANTS[idx] || VARIANTS[2];
            const wide = idx >= 2;
            const wa = waLink(
              `Olá! Vim pelo site da Contabiltec e quero aproveitar a oferta: ${offer.title}.`
            );
            return (
              <Reveal
                key={offer._id}
                delay={idx * 0.08}
                className={`${variant} relative overflow-hidden p-8 md:p-10 flex flex-col ${wide ? "lg:flex-row lg:items-center lg:justify-between lg:gap-10" : "min-h-[380px]"}`}
                testid={`offer-card-${idx}`}
              >
                {idx === 0 && (
                  <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-crimson blur-[100px] opacity-60" />
                )}
                <div className="relative flex-1">
                  {offer.badge && (
                    <span
                      data-testid={`offer-badge-${idx}`}
                      className="inline-block text-[11px] uppercase tracking-[0.2em] font-semibold border border-current/30 rounded-full px-4 py-1.5 opacity-80"
                    >
                      {offer.badge}
                    </span>
                  )}
                  <h3 className="mt-5 font-display font-extrabold tracking-tight text-3xl md:text-4xl leading-tight">
                    {offer.title}
                  </h3>
                  {offer.subtitle && (
                    <p className="mt-2 text-base opacity-70">{offer.subtitle}</p>
                  )}

                  <ul className="mt-7 space-y-3">
                    {offer.items.map((item, i) => (
                      <li key={i} className="flex items-end gap-3" data-testid={`offer-item-${idx}-${i}`}>
                        <span className="text-sm opacity-75 pb-1">{item.label}</span>
                        <span className="flex-1 border-b border-dotted border-current/30 mb-2.5" />
                        <span className="font-display font-extrabold text-2xl md:text-3xl whitespace-nowrap">
                          {item.price}
                        </span>
                      </li>
                    ))}
                  </ul>

                  {offer.footnote && (
                    <p className="mt-5 text-xs opacity-55 flex items-start gap-2">
                      <Clock3 size={14} className="mt-0.5 shrink-0" />
                      {offer.footnote}
                    </p>
                  )}
                </div>

                <a
                  data-testid={`offer-cta-${idx}`}
                  href={wa}
                  target="_blank"
                  rel="noreferrer"
                  className={`relative mt-8 lg:mt-0 inline-flex items-center justify-center gap-2 font-semibold px-7 py-4 rounded-full transition-transform duration-300 hover:scale-[1.03] shrink-0 ${
                    idx === 2
                      ? "bg-crimson text-paper"
                      : "bg-paper text-ink hover:bg-white"
                  }`}
                >
                  <MessageCircle size={18} />
                  Falar com especialista
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
